import { RoundOffPipe } from "./roundOff.pipe";

export const APP_PIPE: any[] = [
	RoundOffPipe,
];

export * from './roundOff.pipe';




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/common/pipe/index.ts